export default __webpack_public_path__ + "static/media/03AW1FEB66.08687da7.jpg";